const moment = require("moment")
require('moment-timezone')
// moment.tz.setDefault("Asia/Seoul")
moment.locale('ko')

moment.prototype.toString = function(format = undefined) {
    if (format == undefined) {
        return this.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    }
    return this.format(format)
}

const wrapper = (input, format = undefined, timezone = undefined) => {
    const vuex = require('@/store').default
    let zone = timezone
    let locale = vuex.state.SaaS.locale
    if (zone == undefined) {
        const timezone = vuex.state.SaaS.timezone
        if (timezone != undefined && timezone != '') {
            zone = timezone
        } else {
            zone = 'Asia/Seoul'
        }
        // console.log('zone : ', zone)
    }

    return moment(input, format).tz(zone).locale(locale)
}

module.exports = wrapper